import './App.css';
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  ScrollRestoration,
  useNavigation,
} from 'react-router';
import { OidcLogout, OidcRedirectCallback } from '@britishcouncil/react-oidc-auth';
import * as Sentry from '@sentry/react';

import { APP_ROUTES } from 'pages';
import { Layout } from 'core';
import { ROUTING_PATHS } from 'const';
import { FullScreenLoader } from 'components';
import { PropsWithChildren } from 'react';
import { useSentry } from 'hooks';
import { Message, MessageHeader, Segment } from 'semantic-ui-react';
import { Breadcrumb } from 'components/breadcrumb/Breadcrumb';

function App() {
  useSentry();

  return <RouterProvider router={router} />;
}

const RouteSuspense = ({ children }: PropsWithChildren) => {
  const navigation = useNavigation();

  if (navigation.state === 'loading') {
    return <FullScreenLoader />;
  }

  return <>{children}</>;
};

const router = createBrowserRouter([
  {
    path: ROUTING_PATHS.logout,
    element: (
      <OidcLogout>
        <FullScreenLoader />
      </OidcLogout>
    ),
  },
  {
    path: ROUTING_PATHS.loginCallback,
    element: (
      <OidcRedirectCallback
        errorCallback={(error) => {
          console.error(error);
        }}
      >
        <FullScreenLoader />
      </OidcRedirectCallback>
    ),
  },
  {
    path: '',
    element: (
      <Layout>
        <ScrollRestoration />
        <Sentry.ErrorBoundary
          fallback={
            <Segment>
              <Message negative>
                <MessageHeader>Sorry...</MessageHeader>
                <p>Something went wrong, please try again</p>
              </Message>
            </Segment>
          }
        >
          <Breadcrumb routes={APP_ROUTES} />
          <RouteSuspense>
            <Outlet />
          </RouteSuspense>
        </Sentry.ErrorBoundary>
      </Layout>
    ),
    children: APP_ROUTES,
  },
]);

export default App;
